import { ReactNode, createContext, useContext, useState } from 'react';

export type AnalyticsInterval = 'day' | 'week' | 'month' | 'quarter' | 'year' | 'custom';

export type AnalyticsIntervalContextType = {
	interval: AnalyticsInterval;
	startDate?: Date;
	endDate?: Date;
	setInterval: (interval: AnalyticsInterval) => void;
	setStartDate: (date?: Date) => void;
	setEndDate: (date?: Date) => void;
};

export const AnalyticsIntervalContext = createContext<AnalyticsIntervalContextType | undefined>(
	undefined,
);

export const AnalyticsIntervalProvider = ({
	children,
	defaultInterval = 'year',
}: {
	children: ReactNode;
	defaultInterval?: AnalyticsInterval;
}) => {
	const [interval, setInterval] = useState<AnalyticsInterval>(defaultInterval);
	const [startDate, setStartDate] = useState<Date | undefined>(undefined);
	const [endDate, setEndDate] = useState<Date | undefined>(undefined);

	return (
		<AnalyticsIntervalContext.Provider
			value={{ interval, setInterval, startDate, setStartDate, endDate, setEndDate }}
		>
			{children}
		</AnalyticsIntervalContext.Provider>
	);
};

export const useAnalyticsInterval = () => {
	const context = useContext(AnalyticsIntervalContext);
	if (context === undefined) {
		throw new Error('useAnalyticsInterval must be used within an AnalyticsIntervalProvider');
	}
	return context;
};
